// extracted by mini-css-extract-plugin
export default {"coverageGuide":"CoverageGuidePage_coverageGuide__x-z3K","content":"CoverageGuidePage_content__L0rCo"};